var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5041 1V5.54763C19.5022 4.97332 18.3372 4.63342 17.0673 4.63342C13.1877 4.63342 10.2168 7.69253 10.2168 11.4666C10.2168 15.2407 13.1877 18.4638 17.0673 18.4638C18.3372 18.4638 19.5022 18.1122 20.5041 17.5145V18.4638H23.9993V1H20.5041ZM17.0906 15.2523C15.3197 15.2523 13.6537 13.8693 13.6537 11.5018C13.6537 9.29828 15.3197 7.80977 17.0906 7.80977C18.8615 7.80977 20.5041 9.29828 20.5041 11.5018C20.5041 13.8576 18.8615 15.2523 17.0906 15.2523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12785 18.4638C7.24099 18.4638 8.14338 17.556 8.14338 16.4362C8.14338 15.3163 7.24099 14.4084 6.12785 14.4084C5.01469 14.4084 4.1123 15.3163 4.1123 16.4362C4.1123 17.556 5.01469 18.4638 6.12785 18.4638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38058 13.3067H7.87573V4.52793H12.2563V1H0V4.52793H4.38058V13.3067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9996,
    height: 18,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.7202265b.svg";
export { ForwardRef as ReactComponent };